import { render, staticRenderFns } from "./ViewContactModal.vue?vue&type=template&id=60bda0de&scoped=true&"
import script from "./ViewContactModal.vue?vue&type=script&lang=js&"
export * from "./ViewContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bda0de",
  null
  
)

export default component.exports